import React from "react";
import { compose, graphql } from "react-apollo";

import { INVENTORY_ENTRIES_QUERY, INVENTORY_ITEMS_QUERY, INVENTORY_QUANTITIES_QUERY } from "views/StockMaterials/stockMaterialsQueries";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import translateErrorMessage from "utils/translateErrorMessage";
import { CREATE_INVENTORY_ENTRY_MUTATION } from "./stockInputMutations";
import StockInputModal from "./StockInputModal";

class StockInputCreate extends React.Component {
  onSubmit = params => {
    this.props.createInventoryEntry({
      variables: { params },
      refetchQueries: [
        { query: INVENTORY_ENTRIES_QUERY },
        { query: INVENTORY_ITEMS_QUERY },
        { query: INVENTORY_QUANTITIES_QUERY },
      ]
    })
      .then(() => {
        this.props.snackbarContext.setNotificationTimeOut(Color.success, "Entrada de estoque criada com sucesso.");
        this.props.toggleModal();
      })
      .catch(error => {
        this.props.snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  }

  render() {
    const {
      isOpen,
      toggleModal,
    } = this.props;

    return (
      <StockInputModal
        title="Cadastrar entrada de estoque"
        onSubmit={this.onSubmit}
        isOpen={isOpen}
        toggleModal={toggleModal}
      />
    );
  }
}

export default compose(
  graphql(CREATE_INVENTORY_ENTRY_MUTATION, { name: "createInventoryEntry", }),
  withSnackbarConsumer,
)(StockInputCreate);
